<template>
  <!-- <ValidationObserver v-slot="{ invalid }" tag="div"> -->
  <TitleWrapper
    :filter-option="true"
    title="PAID"
    tooltip-title="PAID_TOOLTIP"
    :display-breadcrumb="true"
    :displayed-column-options="csvFilterOptions"
    :already-selected-displayed-column="filtersPayload.displayedColumns"
    @applyFilter="applyFilters($event, invalid)"
  >
    <template v-slot:filterItems>
      <div class="mb-5 text-text-color font-roboto font-normal text-lg">Search</div>
      <InputFieldWrapper>
        <UiSingleSelect :title="pluralToSingular(className)" :options="options" />
        <UiSingleSelect title="Section" :options="options" />
        <UiSingleSelect title="Student Id" :options="options" />
        <UiSingleSelect title="Student Name" :options="options" />
      </InputFieldWrapper>
    </template>
  </TitleWrapper>
  <!-- </ValidationObserver> -->
</template>

<script>
import UiSingleSelect from '@/src/components/UiElements/UiSingleSelect.vue'
import TitleWrapper from '@components/TitleWrapper.vue'
import InputFieldWrapper from '@src/components/UiElements/InputFieldWrapper.vue'
import { mapState } from 'vuex'
import { pluralToSingular } from '@utils/generalUtil'
// import { ValidationObserver } from 'vee-validate/dist/vee-validate.full.esm'

export default {
  components: {
    TitleWrapper,
    UiSingleSelect,
    // ValidationObserver,
  },
  props: {
    csvFilterOptions: {
      type: Array,
      default: () => [],
    },
    alreadySelectedDisplayedColumns: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['apply'],
  data() {
    return {
      options: ['Select'],
      filtersPayload: {
        displayedColumns: [],
      },
    }
  },
  computed: {
    ...mapState({
      className: (state) => state.featureNaming.routerList.CLASSES.DISPLAY_NAME,
    }),
  },
  mounted() {
    if (this.alreadySelectedDisplayedColumns && this.alreadySelectedDisplayedColumns.length) {
      this.filtersPayload.displayedColumns = this.alreadySelectedDisplayedColumns
    }
  },
  methods: {
    pluralToSingular,
    applyFilters(event, invalid) {
      this.filtersPayload.displayedColumns = event.displayedColumns
      if (invalid) return
      this.$emit('apply', this.filtersPayload)
    },
  },
}
</script>
